import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 1152 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1152 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu\"><path d=\"M32 32h1080v120H32V32z m0 420h720v120H32V452z m0 420h1080v120H32v-120z\" p-id=\"1042\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol